module.exports = __webpack_public_path__ + "img/jr_childrensday_banner.4f3d6d2c.jpg";